import React from 'react';

import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import { GrammarIntentTestResult } from 'client/model/grammar';
import * as keyset from 'i18n/IntentsPage';

import styles from './GrammarPageTestResult.module.scss';

const t = i18n(keyset);

interface Props {
    results: GrammarIntentTestResult;
}

export const GrammarPageTestResult: React.FC<Props> = ({ results }) => {
    const { trueNegatives, truePositives, falseNegatives, falsePositives, precision, recall } = results;
    const showPositiveSection = truePositives.length > 0 || falseNegatives.length > 0;
    const showNegativeSection = trueNegatives.length > 0 || falsePositives.length > 0;

    return (
        <div className={styles.grammarPageTestResult}>
            <div>
                {t('test-result-occuracy')} {Math.round(precision * 100)}%
            </div>
            <div>
                {t('test-result-completeness')} {Math.round(recall * 100)}%
            </div>
            <br />
            {showPositiveSection && (
                <>
                    <div className={styles.grammarPageTestResult__title}>{t('test-result-positive')}</div>
                    {truePositives.map(({ text }, i) => (
                        <div
                            key={i}
                            className={clx(
                                styles.grammarPageTestResult__line,
                                styles.grammarPageTestResult__line_matched,
                            )}
                        >
                            {text}
                        </div>
                    ))}
                    {falseNegatives.map(({ text }, i) => (
                        <div className={styles.grammarPageTestResult__line} key={i}>
                            {text}
                        </div>
                    ))}
                    <br />
                </>
            )}
            {showNegativeSection && (
                <>
                    <div className={styles.grammarPageTestResult__title}>{t('test-result-negative')}</div>
                    {trueNegatives.map(({ text }, i) => (
                        <div
                            key={i}
                            className={clx(
                                styles.grammarPageTestResult__line,
                                styles.grammarPageTestResult__line_matched,
                            )}
                        >
                            {text}
                        </div>
                    ))}
                    {falsePositives.map(({ text }, i) => (
                        <div key={i} className={styles.grammarPageTestResult__line}>
                            {text}
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};
